<div class="file-input-wrapper">
  <mat-form-field>
    <input matInput
           readonly
           type="text"
           class="file-name-input"
           [(ngModel)]="value"
           [placeholder]="placeholder"
           [disabled]="disabled"
           (click)="fileInput.click()"/>
    <button matPrefix
            mat-icon-button
            class="file-button"
            color="primary"
            (click)="fileInput.click()"
            [disabled]="disabled">
      <mat-icon>attachment</mat-icon>
    </button>
    <input hidden type="file" [accept]="filter" #fileInput (change)="onFileChange($event)"/>
  </mat-form-field>
</div>
